export function getHighlightedText(text: string, highlight: string) {
  // split the search highlight
  const words = highlight.split(/\s+/g).filter((word) => word.length);
  // join if search highlight has more than 1 word
  const pattern = words.join('|');

  const re = new RegExp(pattern, 'gi');
  const children: any[] = [];

  let before,
    highlighted,
    match,
    pos = 0;
  // match using RegExp with my text
  const matches = text.match(re);

  if (matches != null) {
    // loop all the matches
    for (match of matches) {
      match = re.exec(text);

      if (pos < match.index) {
        // before has all the text before the word
        // that has to highlighted
        before = text.substring(pos, match.index);

        if (before.length) {
          children.push(before);
        }
      }
      highlighted = (
        <span
          style={{ fontFamily: 'DMSans-Bold' }}
        >
          {match[0]}
        </span>
      );
      // highlight is highlighted
      children.push(highlighted);

      pos = match.index + match[0].length;
    }
  }
  if (pos < text.length) {
    // text after the highlighted part
    const last = text.substring(pos);
    children.push(last);
  }
  // children array will have the entire text
  return <span>{children}</span>;
}
